<template>
	<a-modal :title="isUpdate ? '修改管理员' : '新增管理员'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="() => { $emit('ok') }" @cancel="() => { $emit('cancel') }">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="form" :label-col="{span:5}" :wrapper-col="{span:15}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>
				<a-form-model-item v-if="!isUpdate" label="账号" prop="account"
					:rules="[
						{ required: true, message: '必填，不能为空', trigger: 'blur' },
						{ validator: isExistAccount, trigger: 'blur' }
					]">
					<a-input v-model="form.account" style="width:300px" />
				</a-form-model-item>
				<a-form-model-item v-if="!isUpdate" label="密码" prop="password"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
					<a-input v-model="form.password" type="password" style="width:300px" />
				</a-form-model-item>
				<a-form-model-item label="姓名" prop="username"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
					<a-input v-model="form.username" style="width:200px" />
				</a-form-model-item>
				<a-form-model-item label="邮箱" prop="mail"
					:rules="[{ validator: isExistMail, trigger: 'blur' }]">
					<a-input v-model="form.mail" />
				</a-form-model-item>
				<a-form-model-item label="手机号" prop="tel"
					:rules="[{ validator: isExistTel, trigger: 'blur' }]">
					<a-input v-model="form.tel" style="width:200px" />
				</a-form-model-item>

				<a-form-model-item label="角色" prop="rolesId"
					:rules="[{ required: true, type: 'array', min: 1, message: '至少选择一个角色', trigger: 'change' }]">
					<a-checkbox-group v-model="form.rolesId" style="width:100%;">
						<a-row :gutter="24">
							<a-col :span="8" v-for="role in roles" :key="role.id">
								<a-checkbox :value="role.id">
									{{role.name}}
								</a-checkbox>
							</a-col>
						</a-row>
					</a-checkbox-group>
				</a-form-model-item>
				<a-form-model-item label="备注" prop="remark">
					<a-textarea v-model="form.remark" :auto-size="{minRows:3, maxRows:5}" />
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';
	import {
		adminAccountIsExist,
		adminTelIsExist,
		adminMailIsExist
	} from '@/api/system/admin';
	import {
		roleOpts
	} from '@/api/system/role';

	const fields = ['id', 'username', 'mail', 'tel', 'rolesId', 'remark', 'account', 'password'];

	function emptyForm() {
		return {
			id: 0,
			account: '',
			password: '',
			username: '',
			mail: '',
			tel: '',
			rolesId: [],
			remark: ''
		};
	}

	function normalizeRolesId(val) {
		if (Array.isArray(val)) {
			return val.map(Number);
		}
		if (val == null || val === '') {
			return [];
		}
		if (typeof val === 'string') {
			try {
				const parsed = JSON.parse(val);
				return Array.isArray(parsed) ? parsed.map(Number) : [];
			} catch (e) {
				return val.split(',').map(s => Number(s.trim())).filter(n => !Number.isNaN(n));
			}
		}
		return [];
	}

	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				roles: [],
				form: emptyForm(),
			}
		},
		created() {
			this.fetchRoles();
			this.$watch('model', (m) => {
				if (!m) {
					this.initForm();
					return;
				}
				const base = pick(m, fields);
				base.rolesId = normalizeRolesId(m.rolesId != null ? m.rolesId : m.roleIds);
				this.$nextTick(() => {
					this.form = { ...emptyForm(), ...base, id: m.id || 0 };
					if (!this.isUpdate) {
						this.form.account = m.account || '';
						this.form.password = '';
					}
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			}, { immediate: true });
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0;
			}
		},
		methods: {
			initForm() {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			fetchRoles() {
				roleOpts().then(res => {
					this.roles = res.data.opts;
				});
			},
			isExistAccount(rule, value, callback) {
				if (!value) {
					callback();
					return;
				}
				if (this.model && this.model.account === value) {
					callback();
					return;
				}
				adminAccountIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('账号已存在'));
					} else {
						callback();
					}
				}).catch(() => callback());
			},
			isExistTel(rule, value, callback) {
				if (value === undefined || value === '') {
					callback();
					return;
				}
				if (this.model && this.model.tel === value) {
					callback();
					return;
				}
				adminTelIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('手机号已存存'));
					} else {
						callback();
					}
				}).catch(() => callback());
			},
			isExistMail(rule, value, callback) {
				if (value === undefined || value === '') {
					callback();
					return;
				}
				if (this.model && this.model.mail === value) {
					callback();
					return;
				}
				adminMailIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('邮箱地址已存在'));
					} else {
						callback();
					}
				}).catch(() => callback());
			}
		}
	}
</script>

<style scoped>

</style>
